// La maîtrise, partout de la même façon : la jauge du système (piste + rempli), son pourcentage en chiffres
// tabulaires, et son mot. La couleur ne classe jamais seule — c'est le mot qui dit où en est l'étudiant, et la
// jauge reste cobalt : quatre jauges de quatre couleurs auraient fait quatre accents de plus.
import { html } from '../../core/html.js';

// Cinq paliers, nommés. Les seuils sont ceux du calcul de maîtrise historique (0,4 / 0,6 / 0,8).
export function motMaitrise(m) {
    if (m == null) return 'jamais testé';
    if (m < 0.4) return 'fragile';
    if (m < 0.6) return 'à reprendre';
    if (m < 0.8) return 'en cours';
    return 'solide';
}
export function classeMaitrise(m) {
    if (m == null) return 'qcm-m-vide';
    if (m < 0.4) return 'qcm-m-bas';
    if (m < 0.6) return 'qcm-m-moyen';
    if (m < 0.8) return 'qcm-m-haut';
    return 'qcm-m-plein';
}
function pourcent(m) { return Math.round((m || 0) * 100); }

// opts : { mot: false } pour les listes très denses (le pourcentage et l'infobulle portent alors le sens),
//        { aide: '…' } pour l'infobulle, { large: true } pour la fiche d'un item.
export function jaugeMaitrise(m, opts) {
    opts = opts || {};
    var mot = motMaitrise(m), p = pourcent(m);
    var aide = opts.aide || (m == null ? 'Jamais testé' : 'Maîtrise ' + p + ' % — ' + mot);
    return html`<span class="qcm-maitrise ${classeMaitrise(m)}${opts.large ? ' qcm-maitrise-large' : ''}" title="${aide}">
        <span class="jauge-piste qcm-maitrise-piste"><span class="jauge-val" style="transform:scaleX(${m == null ? 0 : Math.max(0.02, m)})"></span></span>
        <span class="qcm-maitrise-val num">${m == null ? '—' : p + ' %'}</span>
        ${opts.mot === false ? '' : html`<span class="qcm-maitrise-mot">${mot}</span>`}
    </span>`;
}

// Le rang d'une notion (programme R2C : A ou B, jamais autre chose). Rouge pour le rang A, bleu pour le rang B :
// c'est le code des référentiels, lu d'un coup d'œil par qui révise. Le mot reste écrit — la couleur le double,
// elle ne le remplace pas — et les deux teintes sont à eux (--rang-a / --rang-b), ni le rouge d'erreur ni le cobalt.
export function puceRang(r) {
    if (r === 'A') return html`<span class="puce puce-rang puce-rang-a" title="Rang A : à connaître pour tous">Rang A</span>`;
    if (r === 'B') return html`<span class="puce puce-rang puce-rang-b" title="Rang B : à connaître pour la spécialité">Rang B</span>`;
    return html`<span class="puce puce-rang puce-sans-point rang rang-0" title="Rang non précisé par la banque de questions">Rang ?</span>`;
}

// Le verdict d'une question : le mot d'abord, le barème ensuite, la teinte en dernier.
export function puceScore(s) {
    var mot = s >= 1 ? 'Juste' : s >= 0.5 ? 'Partiel' : s > 0 ? 'Faible' : 'Faux';
    var classe = s >= 1 ? 'puce-ok' : s >= 0.5 ? 'puce-warn' : s > 0 ? 'puce-warn' : 'puce-danger';
    var pts = (Math.round(s * 100) / 100).toString().replace('.', ',');
    return html`<span class="puce ${classe} qcm-score" data-score="${mot}">${mot}<span class="num"> · ${pts} pt</span></span>`;
}

// Avancement d'une séance (QCM, active recall) : une barre cobalt, annoncée comme telle, et son compteur lu à voix.
export function avancement(fait, total, opts) {
    opts = opts || {};
    var pct = total ? Math.max(0, Math.min(1, fait / total)) : 0;
    return html`<div class="qcm-progres">
        <div class="jauge-piste qcm-progres-piste" role="progressbar" aria-valuemin="0" aria-valuemax="${total}" aria-valuenow="${fait}" aria-label="${opts.label || 'Avancement de la séance'}" aria-valuetext="${fait} sur ${total}">
            <span class="jauge-val" style="transform:scaleX(${pct})"></span>
        </div>
        <p class="qcm-progres-compte num" id="${opts.id || 'qcm-compteur'}" aria-live="polite" aria-atomic="true">${opts.texte || (fait + ' / ' + total)}</p>
    </div>`;
}
